import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Tooltip as ReactTooltip } from "react-tooltip";
import firebase from "firebase/compat/app";

const Chapter1_2 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welches Ereignis führte zu einem Wendepunkt in der Wahrnehmung digitaler Bedrohungen?",
      options: [
        {
          value: "A",
          label:
            "Der Morris-Wurm von 1988, der Tausende von Computern lahmlegte.",
        },
        {
          value: "B",
          label: "Die Entwicklung der Enigma-Maschine im Zweiten Weltkrieg.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Welche Abwehrmaßnahme überwacht und kontrolliert den Datenverkehr zwischen Netzwerken seit den späten 1980er Jahren?",
      options: [
        {
          value: "A",
          label: "Firewalls.",
        },
        {
          value: "B",
          label: "Virenschutzprogramme.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

 
  useEffect(() => {
    console.log("Aktuelle userId in 1_2.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
       
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

       
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
         
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "1_2",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("1_2"),
            });
          console.log("Dokument aktualisiert mit Kapitel 1_2.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "1_2",
              completedChapters: ["1_2"],
            });
          console.log("Dokument erstellt mit Kapitel 1_2.");
        }

        navigate("/1_3"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />

        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  Was ist Cybersecurity?
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Meilensteine in der Cybersecurity
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">Kapitel 1: Was ist Cybersecurity?</h3>
          <h2 className="text-center p-3">Meilensteine in der Cybersecurity</h2>
          <img
            src="/images/history.webp"
            alt="Transparent"
            style={{ position: "relative", maxWidth: "40%", height: "auto" }}
          />
        </div>
        <div className="p-5 text-center">
          <p className="col-lg-11 pt-5 mx-auto">
            Die Entstehung der Cybersecurity ist eng mit der Einführung von
            Computern, Netzwerken und dem Internet verknüpft. Mit jeder neuen
            technologischen Weiterentwicklung – sei es die Vernetzung von
            Computern, die Verbreitung des Internet, die Cloud-Revolution oder
            der Aufstieg der KI – entstanden und entstehen neue Bedrohungen.
          </p>
        </div>
        <div className="p-5 text-center">
          <h3 className="pb-5">Die Anfänge</h3>
          <h4 className="gelb pb-5 text-center ">
            Physische Bedrohungen in der Vor-Digitalen Ära{" "}
          </h4>

          <p className="col-lg-11 mx-auto">
            In der Zeit, als Informationen auf Papier festgehalten und in
            Schränken, Tresoren oder gesicherten Räumen aufbewahrt wurden,
            schützten physischen Maßnahmen wie Schlösser oder Wachen gegen den
            unbefugten Zugriff. Diese Art von Sicherheit war greifbar, sichtbar
            und in den meisten Fällen ausreichend.
          </p>

          <p className="col-lg-11 pb-5 mx-auto">
            <img
              src="/images/50.webp"
              class="rounded-circle p-2 float-start"
              alt="50"
              style={{
                maxWidth: "150px",
                height: "150px",
              }}
            />
            Mit der Entwicklung der ersten Großrechner (Mainframes) in den
            1950er Jahren blieben solche Sicherheitsprinzipien zunächst
            erhalten. Die frühen Computer waren groß, teuer und für die meisten
            Menschen unzugänglich. Der Zugang zu diesen Maschinen war streng
            kontrolliert. Sie wurden in speziellen Räumen untergebracht, die oft
            nur von wenigen, speziell geschulten Personen betreten werden
            durften. In dieser Zeit war der Schutz der Maschinen selbst das
            Hauptanliegen.
          </p>
        </div>
        <div className="grey-section">
          <div className="p-5 col-lg-9 mx-auto text-center">
            <h3 className="p-5">Das Arpanet und der ersten Netzwerke</h3>
            <h4 className="gelb pb-5 text-center ">
              Aufkommen erster Sicherheitsbedenken und Bedrohungen{" "}
            </h4>

            <p className="col-lg-11 mx-auto">
              In den 1960er Jahren entstanden auch die ersten Computernetzwerke,
              die zunächst nur wenige Systeme miteinander verbanden, aber bald
              zu immer größeren und komplexeren Netzwerken führten. Eines der
              ersten Netzwerke war das <strong>ARPANET, </strong> das von der
              US-Regierung 1968 am MIT als Forschungsprojekt ins Leben gerufen
              wurde und als Vorläufer des heutigen Internet gilt. ARPANET
              ermöglichte es Wissenschaftlern und Forschern, Daten über große
              Entfernungen auszutauschen, was eine Revolution in der
              Kommunikation und Zusammenarbeit darstellte.
              <br />
              <br />{" "}
              <img
                src="/images/60.webp"
                class="rounded-circle p-2 float-start"
                alt="60"
                style={{
                  maxWidth: "150px",
                  height: "150px",
                }}
              />
              Mit der Einführung der Netzwerke begann sich die
              Bedrohungslandschaft schnell zu ändern. Zuvor waren Computer
              isoliert und durch physische Sicherheitsmaßnahmen geschützt. Aber
              als sie miteinander vernetzt wurden, eröffnete dies völlig neue
              Angriffsmöglichkeiten. Man erkannte, dass Netzwerke nicht nur
              Verbindungen zwischen Computern schaffen, sondern auch potenzielle
              Einfallstore für Angreifer darstellen können.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Der Morris-Wurm wurde 1988 von dem MIT-Studenten Robert Morris
              entwickelt und sollte als Experiment die "Größe" des Internet
              wiedergeben. Durch eine unbeabsichtigte Schwäche in seinem Code
              verbreitete er sich unkontrolliert und legte Tausende von
              Computern lahm, indem er ihre Ressourcen überlastete.
            </p>
            <p className="col-lg-11 mx-auto">
              Der <strong>Morris-Wurm</strong> gilt als einer der ersten
              Angriffe auf vernetzte Systeme. Er markierte einen Wendepunkt in
              der Geschichte der Cybersecurity, da er deutlich machte, wie
              verwundbar vernetzte Systeme waren.
              <br />
              <br />
              Aber auch der unvorsichtige Umgang mit Dateien und Speichermedien
              wurde plötzlich eine Gefahr.
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Der Elk Cloner war ein Virus, der 1982 entwickelt wurde und sich
              über Disketten verbreitete. Dieser Virus verursachte keinen
              ernsthaften Schaden, zeigte aber an jedem 50. Start eines
              infizierten Computers ein Gedicht an und bewies damit, dass sich
              Schadsoftware unbemerkt verbreiten konnte.
            </p>
            <p className="col-lg-11 mx-auto">
              Durch die Einführung von Netzwerken und das Aufkommen der ersten
              digitalen Bedrohungen wurde die Notwendigkeit für spezialisierte
              Sicherheitslösungen deutlich.
              <br />
            </p>
          </div>
        </div>

        <div className="gelb-section">
          <div className="p-5 col-lg-9 mx-auto text-center">
            <h3 className="p-5">Das Internetzeitalter</h3>
            <h4 className="gelb pb-5 text-center ">
              Explosionsartiges Wachstum der Bedrohungen{" "}
            </h4>
            <img
              src="/images/70.webp"
              class="rounded-circle p-2 float-start"
              alt="70"
              style={{
                maxWidth: "150px",
                height: "150px",
              }}
            />

            <p className="col-lg-11 mx-auto">
              Mit der flächendeckenden Verbreitung des Internet in den 1990er
              Jahren begann eine neue Ära in der Cybersecurity. Das Internet
              wurde für Unternehmen, Regierungen und Privatpersonen
              unverzichtbar, doch diese Vernetzung brachte auch eine drastische
              Zunahme der Bedrohungen mit sich. Online-Dienste wie Websites und
              E-Mails wurden essenziell für das tägliche Leben. Viele dieser
              ersten Online-Systeme waren nicht ausreichend gesichert und diese
              Schwachstellen ermöglichten es Angreifern, unbefugten Zugang zu
              Systemen zu erlangen.
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Ein besonders berüchtigter Vorfall war der „ILOVEYOU“-Virus im
              Jahr 2000. Als Liebesbrief getarnt, verbreitete sich dieser Virus
              rasend schnell per E-Mail-Anhang. Er verursachte weltweit
              erhebliche Schäden, indem er Dateien auf den betroffenen Computern
              überschrieb und die Systeme funktionsunfähig machte.
            </p>
            <p className="col-lg-11 mx-auto">
              Der „ILOVEYOU“-Virus verdeutlichte die wachsende Bedrohung durch{" "}
              <strong> E-Mail-basierte Angriffe. </strong> Man erkannte die
              Notwendigkeit, sowohl technische Schutzmaßnahmen als auch die
              Sensibilisierung der Benutzer für die Risiken von Cyberbedrohungen
              zu verstärken.
            </p>
            <p className="col-lg-11 mx-auto">
              Als Reaktion auf die steigenden Bedrohungen entstanden neue
              Sicherheitsmaßnahmen. Eine der bedeutendsten Innovationen war die
              Einführung von <strong>Firewalls</strong>. Sie überwachten und
              kontrollierten den Datenverkehr zwischen Netzwerken, indem sie
              bösartige Verbindungen blockierten. Firewalls wurden schnell zum
              unverzichtbaren Bestandteil der Netzwerksicherheit.
              <br />
              <br />
              Parallel dazu entwickelte sich auch die{" "}
              <strong>Antivirensoftware</strong> weiter. Ursprünglich erkannte
              sie Viren nur anhand bekannter{" "}
              <span
                data-tooltip-id="tooltip-signat"
                data-tooltip-content="Eine Signatur ist ein einzigartiges digitales Muster, das bestimmte Merkmale eines Virus oder einer Malware beschreibt und von Antivirensoftware genutzt wird, um diese zu erkennen."
                className="custom-tooltip-trigger"
              >
                Signaturen{" "}
              </span>{" "}
              (Muster). Mit zunehmender Vielfalt und Komplexität neuer
              Bedrohungen wurde die Software jedoch verbessert. Heute werden
              auch{" "}
              <span
                data-tooltip-id="tooltip-heuristisch"
                data-tooltip-content="Heuristische Analysen sind Methoden, die Bedrohungen erkennen, indem sie verdächtige Verhaltensmuster und Eigenschaften von Dateien analysieren, anstatt nur nach bekannten Virensignaturen zu suchen. Diese Technik ermöglicht es, auch neue oder leicht veränderte Schadsoftware zu identifizieren, die noch nicht in einer Datenbank erfasst ist."
                className="custom-tooltip-trigger"
              >
                heuristische Analysen{" "}
              </span>{" "}
              und Verhaltensüberwachung verwendet, um Angriffe zu erkennen und
              abzuwehren.
              <br />
              <br />
            </p>
            <ReactTooltip
              id="tooltip-heuristisch"
              place="top"
              className="custom-tooltip"
            />
            <ReactTooltip
              id="tooltip-signat"
              place="top"
              className="custom-tooltip"
            />
          </div>
        </div>

        <div className="white-section">
          <div className="p-5 col-lg-9 mx-auto text-center">
            <h3 className="p-5">Das Zeitalter der Cloud</h3>
            <h4 className="gelb pb-5 text-center ">
              Die Verlagerung von Daten und Anwendungen in die digitale Welt
            </h4>
            <img
              src="/images/90.webp"
              class="rounded-circle p-2 float-start"
              alt="90"
              style={{
                maxWidth: "150px",
                height: "150px",
              }}
            />

            <p className="col-lg-11 mx-auto">
              Mit dem Aufkommen der Cloud-Technologie in den 2000er Jahren
              veränderte sich die Art und Weise gundlegend, wie Unternehmen und
              Privatpersonen IT-Ressourcen nutzen. Die Cloud brachte enorme
              Vorteile wie Flexibilität, Skalierbarkeit und Kosteneffizienz,
              indem sie es ermöglicht, Daten und Anwendungen nicht mehr lokal,
              sondern in entfernten Rechenzentren zu speichern und zu verwalten.
              Unternehmen können ihre IT-Infrastrukturen in die Cloud verlagern,
              Kosten sparen und ihre Effizienz steigern.
              <br />
              <br />
              Diese Vorteile gingen jedoch mit neuen, komplexen
              Sicherheitsherausforderungen einher. Zu den größten Risiken
              gehören{" "}
              <span
                data-tooltip-id="tooltip-data"
                data-tooltip-content="Ein Datenleck ist ein Vorfall, bei dem vertrauliche oder sensible Informationen ungewollt an die Öffentlichkeit oder unbefugte Personen gelangen. Dies kann durch Sicherheitslücken, menschliche Fehler, Hackerangriffe oder ungesicherte Systeme geschehen und kann dazu führen, dass persönliche Daten, Finanzinformationen, Geschäftsdaten oder andere schützenswerte Informationen offengelegt werden. Datenlecks stellen ein großes Risiko für die Privatsphäre und die Sicherheit der Betroffenen dar."
                className="custom-tooltip-trigger"
              >
                {" "}
                Datenlecks{" "}
              </span>{" "}
              (Data Breach) und der Verlust der direkten Kontrolle über
              physische Server. Unternehmen müssen sich daher auf die
              Sicherheitsmaßnahmen ihrer Cloud-Service-Provider verlassen. Diese
              Abhängigkeit führte zu einer verstärkten Zusammenarbeit an
              gemeinsamen <strong> Sicherheitsmodellen.</strong>
            </p>
            <ReactTooltip
              id="tooltip-data"
              place="top"
              className="custom-tooltip"
            />
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Ein bekanntes Beispiel für ein massives Datenleck in der Cloud ist
              der Dropbox-Leak von 2012. Bei diesem Angriff wurden über 68
              Millionen Benutzerkonten kompromittiert, als Hacker in das
              Cloud-basierte Speichersystem von Dropbox eindrangen. Die
              gestohlenen Daten, einschließlich E-Mail-Adressen und Passwörter,
              wurden später im Dark Web zum Verkauf angeboten.{" "}
            </p>
          </div>
        </div>
        <div className="gelb-section">
          <div className="p-5 col-lg-9 mx-auto text-center">
            <h3 className="p-5">Die Ära der Künstlichen Intelligenz (KI)</h3>
            <h4 className="pb-5 text-center ">Neue Chancen und Risiken </h4>

            <img
              src="/images/2020.png"
              class="rounded-circle p-2 float-start"
              alt="2020"
              style={{
                maxWidth: "150px",
                height: "150px",
              }}
            />

            <p>
              Künstliche Intelligenz (KI) ist zu einem unverzichtbaren Werkzeug
              geworden, das die Art und Weise, wie Menschen arbeiten,
              grundlegend verändert. Sie ermöglicht es, Routineaufgaben zu
              automatisieren, Prozesse zu beschleunigen und komplexe
              Datenanalysen in Sekundenschnelle durchzuführen, was ohne KI
              schlicht unmöglich wäre. Durch maschinelles Lernen kann KI aus
              riesigen Datenmengen neue Informationen gewinnen, Muster erkennen
              und präzise Vorhersagen treffen, die die Entscheidungsfindung in
              Unternehmen enorm verbessern.
              <br />
              <br />
              KI und maschinelles Lernen haben die Cybersecurity verändert. Sie
              bieten innovative Möglichkeiten, Bedrohungen in
              <strong> Echtzeit </strong>zu erkennen und sofort darauf zu
              reagieren. Durch die Analyse riesiger Datenmengen identifiziert KI
              Muster und Anomalien, die auf potenziell schädliche Aktivitäten
              hindeuten, oft schon bevor ein Angriff tatsächlich stattfindet.
              KI-basierte Systeme überwachen Verhaltensmuster in Netzwerken und{" "}
              <span
                data-tooltip-id="tooltip-end"
                data-tooltip-content="Endgeräte sind Geräte, die direkt von Nutzern verwendet werden und am „Ende“ eines Netzwerks stehen, wie z. B. Computer, Smartphones, Tablets oder Drucker. Sie dienen als Schnittstelle zwischen dem Benutzer und dem Netzwerk und sind oft ein Ziel für Cyberangriffe."
                className="custom-tooltip-trigger"
              >
                Endgeräten{" "}
              </span>{" "}
              und können automatisch auf verdächtige Aktivitäten reagieren –
              ohne direktes menschliches Eingreifen. Dank ihrer Fähigkeit,
              kontinuierlich zu lernen und sich an neue Bedrohungen anzupassen,
              verbessern solche Systeme die Abwehr von Cyberangriffen erheblich.
              <br />
              <br />
              Doch KI verbessert nicht die Verteidigung - auch Angreifer nutzen
              diese Technologie für ihre Zwecke.{" "}
              <strong>
                KI-gesteuerte Angriffe passen ihr Verhalten dynamisch an,{" "}
              </strong>{" "}
              um Erkennungssysteme zu umgehen und unentdeckt Schaden
              anzurichten. Ebenso ermöglichen es Deepfake-Technologien,
              täuschend echte gefälschte Videos und Audiodateien zu erstellen,
              um sich kriminelle Vorteile zu verschaffen. Diese Entwicklungen
              machen deutlich, dass KI nicht nur Schutz bietet, sondern auch
              völlig neue Bedrohungen schafft. Das erfordert ein erneutes
              Umdenken in der Cybersecurity-Strategie, da herkömmliche
              Schutzmaßnahmen gegen derart dynamische Angriffe oft nicht mehr
              ausreichen.
            </p>
            <ReactTooltip
              id="tooltip-end"
              place="top"
              className="custom-tooltip"
            />
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Ein bekanntes Beispiel für den Einsatz von Deepfake-Technologie in
              der Cyberkriminalität ist ein Vorfall aus dem Jahr 2019, bei dem
              Betrüger eine Deepfake-Stimme einsetzten. Der Manager eines
              britischen Energieanbieters glaubte, mit dem CEO des deutschen
              Mutterkonzerns zu sprechen. In Wirklichkeit handelte es sich um
              dessen manipulierte Stimme. Die gefälschte Stimme forderte den
              britischen Geschäftsführer auf, eine dringende Überweisung von
              220.000 Euro an einen vermeintlichen Lieferanten durchzuführen.
              Der britische Manager führte die Anordnung umgehend aus.
            </p>
          </div>
        </div>
      </div>

      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-10 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter1_2;
